<template>
    <div class="page-wrapper bg-white radius-lg padding margin-left-sm">
        <div class="search-container min flex align-center">
            <div class="flex align-center">
                <el-input  v-model="keyword" placeholder="请输入关键字"></el-input>
                <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
            </div>
        </div>
        <div class="page-list flex flex-direction margin-top-sm">
            <div class="document flex flex-direction radius margin-bottom-sm" v-for="(item,index) in lists" :key="index">
                <div class="flex flex-direction ">
                    <div class="document-name flex align-center justify-between padding-lr-sm">
                        <div class="title text-df text-red text-bold">
                            <i class="el-icon-folder-opened text-bold text-red margin-right-xs"></i>{{item.p_name}} - 成果汇总
                        </div>
                    </div>
                    <div class="margin-left-sm file flex align-center justify-between padding-right-xl">
                        <div class="flex-twice flex align-start justify-start">
                            <div :href="item.path" class="text-sm cursor" target="_blank" @click="previewFile(item)">
                                {{ item.name }}
                            </div>
                        </div>
                        <div class="text-sm">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
            <empty v-if="!lists.length" class="self-center"></empty>
            <el-pagination
                hide-on-single-page
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top self-end"
                layout="prev, pager, next"
                @current-change="init">
            </el-pagination>
        </div>
    </div>
</template>

<script>

import {getProjectPostOutcomeFile} from "@/api";
import {TOAST, toast} from "@/utils/utils";
import {DOMAIN_HTTP} from "@/config";

export default {
    name: "outcome-search",
    components: {},
    data() {
        return {
            keyword:'',
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
        }
    },
    created() {
        this.$emit('setIndex', [1,7], '项目成果汇总', true)
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            this.loading = true
            let _data = await getProjectPostOutcomeFile('','',this.keyword,this.page,this.limit)
            this.loading = false
            this.lists = _data.data.data
            this.total = _data.data.total
        },
        search() {
            if (!this.keyword) return toast('请输入关键字',TOAST.error)
            this.page = 1
            this.init()
        },
        toPage(path) {
            this.$router.push(path)
        },
        previewFile(file) {
            const href= `${DOMAIN_HTTP}/file/preview?fid=${file.id}&type=3`
            window.open(href, '_blank')
        }
    },
    filters:{

    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .document {
        border: solid 1px #e6e6e6;

        .document-name {
            height: 61px;
        }

        .file {
            height: 55px;
        }

        .file + .file {
            border-top: 1px solid var(--ghostWhite);
        }
    }
}
</style>
